import {
  reducer as mainPageReducer,
  namespace as mainPageNamespace,
} from '@redact-modules/mainPage';
import {
  reducer as caseManagementReducer,
  namespace as caseManagementNamespace,
} from '@cbsa-modules/mainPage';
import {
  reducer as documentsReducer,
  namespace as documentsNamespace,
} from '@redact-modules/documents';

export const redactReducers = {
  [mainPageNamespace]: mainPageReducer,
  [caseManagementNamespace]: caseManagementReducer,
  [documentsNamespace]: documentsReducer,
};
